import { getTheme } from "@clipboard-health/ui-theme";
import { Box, GlobalStyles, ThemeProvider } from "@mui/material";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";

import { CHAT_MESSAGE_SPACING } from "./constants";

export function ChatPageWrapper(props: { children: React.ReactNode }) {
  const { children } = props;

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <GlobalStyles
          styles={(theme) => ({
            ".chat-container": {
              height: "100%",
              "max-width": "1000px",
              width: "100%",
              margin: "auto",

              "--sendbird-light-ondark-01": "white",
              "--sendbird-light-primary-500": "#0a67fd",
              "--sendbird-light-primary-400": "#297bff",
              "--sendbird-light-primary-300": "#3e87fd",
              "--sendbird-light-primary-200": "#96bdfd",
              "--sendbird-light-primary-100": "#b1cfff",
            },

            ".chat-container .sendbird-conversation__footer": {
              paddingBottom: theme.spacing(5),
              display: "flex",
              justifyItems: "center",
              flexDirection: "column",
              margin: 0,
            },

            ".chat-container .sendbird-conversation__footer__typing-indicator": {
              position: "relative",
              justifyContent: "center",
              paddingTop: theme.spacing(4),
            },

            ".chat-container .sendbird-conversation__footer__typing-indicator__text": {
              color: theme.palette.text.secondary,
              fontWeight: 400,
            },

            ".chat-container .sendbird-disabled-chat": {
              display: "block",
              textAlign: "center",
              color: "gray",
              padding: `${theme.spacing(4)} 0 ${theme.spacing(5)} 0`,
            },

            ".sendbird-chat-header": {
              paddingRight: 0,
              paddingLeft: "8px",
            },

            ".sendbird-chat-header__left": {
              marginRight: 0,
            },

            ".sendbird-chat-header__right": {
              display: "none",
            },

            ".sendbird-chat-header--avatar--group-channel": {
              display: "none",
            },

            ".sendbird-custom-chat-header": {
              padding: "16px 22px",
              borderBottom: "1px solid var(--sendbird-light-onlight-04)",
              fontSize: "22px",
              fontWeight: "normal",

              ".header-description": {
                fontSize: "16px",
                color: "gray",
              },
            },

            ".sendbird-text-message-item-body .sendbird-text-message-item-body__message": {
              wordBreak: "break-word",
            },

            ".sendbird-fileviewer": {
              position: "fixed",
              inset: 0,
              paddingTop: "env(safe-area-inset-top)",
            },

            ".sendbird-fileviewer__header__right__actions__close": {
              borderLeft: "none !important",
            },

            ".sendbird-fileviewer .sendbird-fileviewer__header .sendbird-fileviewer__header__left":
              {
                overflow: "hidden", // keeps file viewer header buttons on screen
              },

            "@media (max-width: 600px)": {
              ".sendbird-dropdown__menu": {
                left: "33% !important",
              },
            },

            ".chat-container .sendbird-conversation": {
              border: "none",
            },

            ".chat-container [class*='sendbird-']": {
              fontFamily: "PPNeueMontreal, sans-serif !important",
            },

            ".sendbird-message-content.incoming .sendbird-message-content__left": {
              minWidth: 0,
            },

            ".sendbird-message-status": {
              alignItems: "flex-end",
            },

            ".sendbird-message-status .sendbird-message-status__text, .sendbird-message-content.incoming .sendbird-message-content__middle__body-container__created-at":
              {
                color: theme.palette.text.secondary,
                fontSize: "10px",
              },

            ".sendbird-message-status__icon": {
              top: "2px !important", // horizontally align icons with bottom of message bubble
            },

            ".sendbird-message-content__middle__body-container__created-at": {
              bottom: "0px !important",
            },

            ".chat-container .sendbird-file-message-item-body.incoming": {
              backgroundColor: theme.palette.secondary.main,
            },

            ".chat-container .sendbird-file-message-item-body.outgoing": {
              backgroundColor: theme.palette.info.light,
            },

            ".chat-container .sendbird-textbutton, .chat-container .sendbird-file-message-item-body__file-name__text":
              {
                color: theme.palette.text.primary,
              },

            ".chat-container .sendbird-conversation__scroll-bottom-button": {
              "--sendbird-light-primary-300": theme.palette.icon?.primary, // override button icon color
              zIndex: 4,
              backgroundColor: theme.palette.background.tertiary,
              boxShadow: `inset 0 0 0 ${theme.borderWidth?.regular} ${
                theme.palette.border!.primary
              }`,
              "&:hover": {
                boxShadow: `inset 0 0 0 ${theme.borderWidth?.regular} ${
                  theme.palette.border!.main
                }`,
                backgroundColor: theme.palette.background?.tertiary,
              },
            },

            ".chat-container .sendbird-conversation__messages .sendbird-admin-message": {
              padding: 0,
              marginBottom: theme.spacing(CHAT_MESSAGE_SPACING),
            },

            ".chat-container .sendbird-admin-message__text": {
              color: theme.palette.text.tertiary,
              fontWeight: 500,
            },

            ".chat-container .sendbird-thumbnail-message-item-body": {
              minWidth: 0,
              aspectRatio: "4 / 3",
              height: "52.5vw",
              maxWidth: "360px", // Sendbird defaults
              maxHeight: "270px", // Sendbird defaults
            },

            ".chat-container .sendbird-image-renderer, .chat-container .sendbird-image-renderer__image":
              {
                width: "100% !important",
                height: "100% !important",
                minWidth: "0 !important",
              },

            ".sendbird-message-content__middle__body-container": {
              maxWidth: "70vw",
            },

            ".chat-container .sendbird-quote-message__replied-to__text": {
              fontWeight: 500,
            },
          })}
        />
        <Box className="chat-container">{children}</Box>
      </PageWrapper>
    </ThemeProvider>
  );
}
